

import { ArticleData } from "./types";

export const adsRanking: ArticleData = {
  id: 104,
  slug: "ads-ranking",
  title: "Design an Ads recommendation system",
  author: "HelloML",
  publishDate: "May 10, 2025",
  lastUpdated: "May 10, 2025",
  category: "ML System Design",
  readTime: "30 min read",
  readCount: 0,
  likeCount: 0,
  isPremium: true,
  contentType: "html",
  description: "This article provides an overview of designing an Ads ranking system for Facebook, focusing specifically on Instagram Feed, covering everything from system architecture to handling position bias and cold starts. The article breaks down core components like targeting, ranking, pricing, and user experience, with special emphasis on how an E6/Staff engineer might approach this ML design.",
  tags: ["advertising", "recommendation", "system design"],
  featured: true,
  images: {
    image2: "https://res.cloudinary.com/dvxgyuvxl/image/upload/v1748064576/ads_djjgpj.png"
  }
};

